/**
 * systems.js — content module for /systems spoke page.
 * DRAFT — PENDING SAKIB REVIEW
 * Synthesised from _seo/00-seo-plan.md §6 + _seo/04-seo-cluster.md §2 Cluster D
 */

export const systemsHead = {
  eyebrow: 'Category',
  heading: 'AI-native business systems',
  subheading: 'What the phrase means, why it matters, and the three ways we deliver it.',
};

/** @DRAFT */
export const systemsDefinition = {
  heading: 'What is an AI-native business system?',
  paragraphs: [
    'An AI-native business system is a production-grade automation built specifically for your workflow. Designed from the ground up for AI, not retrofitted around a SaaS platform.',
    'It is not an AI employee making autonomous decisions you cannot control. It is not a no-code tool that breaks when your workflow has a branch. It is not locked into a vendor subscription. It is not a chatbot trained on your docs.',
    'It is a system that does bounded work, does it right, and gives you the source code when it is done. Deterministic where the work is predictable, AI only where judgement is genuinely required. You own it. Your team runs it. When AI tooling evolves, you extend it without waiting on a vendor roadmap.',
  ],
};

/** @DRAFT — Three-doors-in routing block (P0-9: MUST render above the fold) */
export const threeDoorsIn = {
  heading: 'Three ways in',
  doors: [
    {
      title: 'The Foundry',
      subtitle: 'Build it yourself, with us',
      description: 'For founders who want to understand and own the system. Six-week AI cohort.',
      href: '/foundry',
      cta: 'Learn about the Foundry',
    },
    {
      title: 'Fully Automated Business Systems',
      subtitle: 'We build it for you',
      description: 'For operators who need the system working. Custom automation and platform development.',
      href: '/automated-systems',
      cta: 'Scope a system',
    },
    {
      title: 'Team Training',
      subtitle: 'Upskill your existing team',
      description: 'For leaders who want their people ready to maintain it. One-session curriculum.',
      href: '/team-training',
      cta: 'Scope a session',
    },
  ],
};

/** @DRAFT */
export const systemsBody = {
  heading: 'Why this category exists',
  paragraphs: [
    'Most AI adoption in operating businesses follows one of two patterns: either a consulting firm sells a strategy deck and walks away, or a SaaS vendor locks you into their platform and their pricing. Both leave you dependent.',
    'AI-native business systems are the third path. Scoped, built, and delivered as source code you own. Training included so your team can operate and extend the system after handoff. No hourly billing, no subscription lock-in, no vendor dependency.',
    'We serve founders and senior operators of $1M to $10M businesses, in Australia and worldwide, whose operational tools have cracked under growth. The systems we build run on AI from the ground up, not bolted onto existing software as an afterthought.',
  ],
};

export const systemsCta = {
  label: 'Talk to us about your systems',
};
